/**
 * @generated SignedSource<<1c767726cf385f2dc2fce3a8b5098984>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetByIdViewQuery$variables = {
  id?: string | null | undefined;
};
export type AssetByIdViewQuery$data = {
  readonly assetById: {
    readonly __typename: string;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly isActive: boolean | null | undefined;
    readonly isBuyActive: boolean | null | undefined;
    readonly isEnabledForOrders: boolean | null | undefined;
    readonly isSellActive: boolean | null | undefined;
    readonly legalUrl: string | null | undefined;
    readonly logoUrl: string | null | undefined;
    readonly marketCap: number | null | undefined;
    readonly minimumBuyAmount: PrecisionFloat | null | undefined;
    readonly minimumSellAmount: PrecisionFloat | null | undefined;
    readonly monthlyVolatility: number | null | undefined;
    readonly name: string | null | undefined;
    readonly openHours?: {
      readonly lastCloseTime: TimeScalar | null | undefined;
      readonly lastOpenTime: TimeScalar | null | undefined;
      readonly nextChange: TimeScalar | null | undefined;
      readonly open: boolean | null | undefined;
      readonly wasOpenToday: boolean | null | undefined;
    } | null | undefined;
    readonly portfolio: {
      readonly assetBalance: PrecisionFloat | null | undefined;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly assets: {
            readonly edges: ReadonlyArray<{
              readonly assetBalance: PrecisionFloat | null | undefined;
              readonly fiatTotalStakedAmount: PrecisionFloat | null | undefined;
              readonly stakedBalance: ValueChange | null | undefined;
              readonly totalInvested: PrecisionFloat | null | undefined;
              readonly totalReturn: ValueChange | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly fiatBalance: PrecisionFloat | null | undefined;
    } | null | undefined;
    readonly price: PrecisionFloat | null | undefined;
    readonly price52WeeksHigh: PrecisionFloat | null | undefined;
    readonly price52WeeksLow: PrecisionFloat | null | undefined;
    readonly priceBuy: PrecisionFloat | null | undefined;
    readonly priceChange1Month: ValueChange | null | undefined;
    readonly priceChange1Week: ValueChange | null | undefined;
    readonly priceChange1Year: ValueChange | null | undefined;
    readonly priceChange24Hours: ValueChange | null | undefined;
    readonly priceChange5Years: ValueChange | null | undefined;
    readonly priceDailyHigh: PrecisionFloat | null | undefined;
    readonly priceDailyLow: PrecisionFloat | null | undefined;
    readonly priceSell: PrecisionFloat | null | undefined;
    readonly staking?: {
      readonly enabled: boolean | null | undefined;
      readonly minimumStakeableAmount: PrecisionFloat | null | undefined;
    } | null | undefined;
    readonly symbol: string | null | undefined;
  } | null | undefined;
};
export type AssetByIdViewQuery = {
  response: AssetByIdViewQuery$data;
  variables: AssetByIdViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetBalance",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MarketOpenHours",
    "kind": "LinkedField",
    "name": "openHours",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "open",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextChange",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wasOpenToday",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastOpenTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastCloseTime",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "assetById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "symbol",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "logoUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "price",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketCap",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "legalUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priceDailyHigh",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priceDailyLow",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "price52WeeksHigh",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "price52WeeksLow",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "monthlyVolatility",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priceChange24Hours",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priceChange1Week",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priceChange1Month",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priceChange1Year",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priceChange5Years",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priceSell",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "priceBuy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "minimumBuyAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "minimumSellAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isBuyActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSellActive",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isEnabledForOrders",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AssetPortfoliosConnection",
        "kind": "LinkedField",
        "name": "portfolio",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fiatBalance",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetPortfoliosEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Portfolio",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioAssetsConnection",
                    "kind": "LinkedField",
                    "name": "assets",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfolioAssetsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalReturn",
                            "storageKey": null
                          },
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalInvested",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stakedBalance",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fiatTotalStakedAmount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetStaking",
            "kind": "LinkedField",
            "name": "staking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minimumStakeableAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabled",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "CryptoAsset",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v2/*: any*/),
        "type": "EquityStockAsset",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v2/*: any*/),
        "type": "EquityEtfAsset",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v2/*: any*/),
        "type": "EquityEtcAsset",
        "abstractKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssetByIdViewQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssetByIdViewQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d6323d517dc1e41ccac3c8f0d168117b",
    "id": null,
    "metadata": {},
    "name": "AssetByIdViewQuery",
    "operationKind": "query",
    "text": "query AssetByIdViewQuery(\n  $id: ID\n) {\n  assetById(id: $id) {\n    id\n    name\n    symbol\n    isActive\n    logoUrl\n    price\n    description\n    marketCap\n    legalUrl\n    priceDailyHigh\n    priceDailyLow\n    price52WeeksHigh\n    price52WeeksLow\n    monthlyVolatility\n    priceChange24Hours\n    priceChange1Week\n    priceChange1Month\n    priceChange1Year\n    priceChange5Years\n    priceSell\n    priceBuy\n    minimumBuyAmount\n    minimumSellAmount\n    isBuyActive\n    isSellActive\n    isEnabledForOrders\n    portfolio {\n      fiatBalance\n      assetBalance\n      edges {\n        node {\n          assets {\n            edges {\n              totalReturn\n              assetBalance\n              totalInvested\n              stakedBalance\n              fiatTotalStakedAmount\n            }\n          }\n        }\n      }\n    }\n    ... on CryptoAsset {\n      staking {\n        minimumStakeableAmount\n        enabled\n      }\n    }\n    ... on EquityStockAsset {\n      openHours {\n        open\n        nextChange\n        wasOpenToday\n        lastOpenTime\n        lastCloseTime\n      }\n    }\n    ... on EquityEtfAsset {\n      openHours {\n        open\n        nextChange\n        wasOpenToday\n        lastOpenTime\n        lastCloseTime\n      }\n    }\n    ... on EquityEtcAsset {\n      openHours {\n        open\n        nextChange\n        wasOpenToday\n        lastOpenTime\n        lastCloseTime\n      }\n    }\n    __typename\n  }\n}\n"
  }
};
})();

(node as any).hash = "af67d883a11c72f9fc19de2aea733b62";

export default node;
